module.exports = __webpack_public_path__ + "img/progress_068.cca4de1f.png";